/** Shared scroll lock while any PDP side drawer is open (iOS needs body position:fixed). */
var pdpSidebarScrollLockCount = 0;
var pdpSidebarSavedScrollY = 0;
var pdpSidebarTouchGuardReady = false;
var pdpSidebarTouchLastY = 0;

/** Ignore sidebar-trigger clicks until the page has fully finished loading. */
var pdpSidebarPageLoaded = document.readyState === 'complete';
if (!pdpSidebarPageLoaded) {
  window.addEventListener('load', function () {
    pdpSidebarPageLoaded = true;
  }, { once: true });
}

function isPdpSidebarOpen() {
  return !!document.querySelector('.pdp-sidebar.is-open, .klaviyo-bis__panel.is-open');
}
window.isPdpSidebarOpen = isPdpSidebarOpen;

function bindPdpSidebarTouchGuard() {
  if (pdpSidebarTouchGuardReady) return;
  pdpSidebarTouchGuardReady = true;
  document.addEventListener(
    'touchstart',
    function (e) {
      if (!isPdpSidebarOpen()) return;
      pdpSidebarTouchLastY = e.touches[0].clientY;
    },
    { passive: true }
  );
  document.addEventListener(
    'touchmove',
    function (e) {
      if (!isPdpSidebarOpen()) return;
      var drawerBody = e.target.closest('.pdp-sidebar__body, .klaviyo-bis__body');
      if (drawerBody) {
        var y = e.touches[0].clientY;
        var dy = pdpSidebarTouchLastY - y;
        pdpSidebarTouchLastY = y;
        var scrollable = drawerBody.scrollHeight > drawerBody.clientHeight + 2;
        if (!scrollable) {
          if (e.cancelable) e.preventDefault();
          return;
        }
        var atTop = drawerBody.scrollTop <= 0;
        var atBottom =
          drawerBody.scrollTop + drawerBody.clientHeight >= drawerBody.scrollHeight - 1;
        if ((atTop && dy < 0) || (atBottom && dy > 0)) {
          if (e.cancelable) e.preventDefault();
        }
        return;
      }
      if (e.cancelable) e.preventDefault();
    },
    { passive: false }
  );
}

/**
 * Desktop layout (>=1024px, where .product__column-sticky is position:sticky):
 * body{position:fixed} makes <body> the scroll container for every sticky descendant
 * (media gallery, thumbnail strip, pagination), and since body's own scrollTop is 0
 * they all jump up and leave a gap below the gallery. overflow:hidden on <html> alone
 * stops the page scrolling while keeping the viewport as the scroll container, so
 * nothing moves (touch scrolling is still blocked by bindPdpSidebarTouchGuard).
 * Smaller viewports keep the body-fixed lock below untouched.
 */
var pdpSidebarDesktopLockActive = false;

function isPdpSidebarDesktopLayout() {
  return window.matchMedia('(min-width: 1024px)').matches;
}

function lockPdpSidebarDesktopScroll() {
  var html = document.documentElement;
  var body = document.body;
  pdpSidebarDesktopLockActive = true;
  // Kiwi's size-chart flow may already have frozen body to position:fixed before this
  // runs — undo it and put the page back where it was, otherwise the gap still shows.
  if (getComputedStyle(body).position === 'fixed') {
    body.style.removeProperty('position');
    body.style.removeProperty('top');
    html.style.overflow = 'hidden';
    window.scrollTo(0, pdpSidebarSavedScrollY);
  }
  // base.css gives body overflow-x:hidden. That normally propagates to the viewport, but
  // once <html> is overflow:hidden it stops propagating and body itself becomes a scroll
  // container (hidden forces overflow-y:auto) — breaking the sticky gallery the same way
  // position:fixed did. overflow-x:clip hides sideways overflow without being a scroller.
  body.style.setProperty('overflow-x', 'clip', 'important');
  body.style.setProperty('overflow-y', 'visible', 'important');
  // Keep the scrollbar's space reserved so hiding it doesn't shift content sideways.
  html.style.setProperty('scrollbar-gutter', 'stable');
  html.style.setProperty('overflow', 'hidden', 'important');
}

function unlockPdpSidebarDesktopScroll() {
  var html = document.documentElement;
  pdpSidebarDesktopLockActive = false;
  html.style.removeProperty('overflow');
  html.style.removeProperty('scrollbar-gutter');
  document.body.style.removeProperty('overflow-x');
  document.body.style.removeProperty('overflow-y');
  if (window._parallaxResumePanelReveal) window._parallaxResumePanelReveal();
}

function lockPdpSidebarPageScroll() {
  pdpSidebarScrollLockCount += 1;
  if (pdpSidebarScrollLockCount > 1) return;
  bindPdpSidebarTouchGuard();
  // body{position:fixed} below takes the body out of flow, so <html> immediately has
  // nothing left to scroll and window.scrollY snaps to 0 — the mobile parallax panel's
  // reveal is driven by real scroll position, so that zero reads as "scrolled back to
  // the top" and the expanded panel visibly collapses (the accordion trigger jumps up,
  // leaving a gap of white space) the instant any of these sidebars opens. Freeze its
  // reveal progress first so it ignores that scroll-position glitch entirely — same fix
  // already applied for the Kiwi size-chart modal lock in product-parallax-mobile.js.
  if (window._parallaxPausePanelReveal) window._parallaxPausePanelReveal();
  // For the Size & Fit Guide flow, Kiwi's own click handling (fireKiwiSuppressed) may
  // already have applied its own scroll lock by the time this runs, which zeroes
  // window.scrollY the same way this lock's own body{position:fixed} would — use the
  // real position captured right before that happened instead of the now-stale 0.
  if (typeof window.__pdpSidebarPreLockScrollY === 'number') {
    pdpSidebarSavedScrollY = window.__pdpSidebarPreLockScrollY;
    window.__pdpSidebarPreLockScrollY = null;
  } else {
    pdpSidebarSavedScrollY = window.scrollY;
    // iOS Safari: window.scrollY can lag behind the real position by the dynamic
    // toolbar's own scroll-anchoring for a frame right around a tap (same quirk
    // product-parallax-mobile.js's applyKiwiBodyScrollGuard already corrects for on
    // the Kiwi lock path) — visualViewport.pageTop isn't subject to that anchoring,
    // so prefer it whenever the two disagree by more than a rounding error.
    if (window.visualViewport && typeof window.visualViewport.pageTop === 'number') {
      var vpTop = Math.round(window.visualViewport.pageTop);
      if (Math.abs(vpTop - pdpSidebarSavedScrollY) > 5) {
        pdpSidebarSavedScrollY = vpTop;
      }
    }
  }
  if (isPdpSidebarDesktopLayout()) {
    lockPdpSidebarDesktopScroll();
    return;
  }
  document.documentElement.classList.add('pdp-sidebar-scroll-lock');
  document.body.classList.add('pdp-sidebar-scroll-lock');
  document.documentElement.style.overflow = 'hidden';
  document.body.style.setProperty('position', 'fixed', 'important');
  document.body.style.setProperty('top', '-' + pdpSidebarSavedScrollY + 'px', 'important');
  document.body.style.setProperty('left', '0', 'important');
  document.body.style.setProperty('right', '0', 'important');
  document.body.style.setProperty('width', '100%', 'important');
  document.body.style.setProperty('overflow', 'hidden', 'important');
}

function unlockPdpSidebarPageScroll() {
  // Guard BEFORE decrementing: if nothing was actually locked, bail out without
  // touching scroll at all — a stray extra unlock call (e.g. two close triggers firing
  // for one interaction) would otherwise re-run the restore below using the stale saved
  // scrollY and yank the page back to it even after the user has since scrolled away,
  // reading as the page being "stuck".
  if (pdpSidebarScrollLockCount === 0) return;
  pdpSidebarScrollLockCount -= 1;
  if (pdpSidebarScrollLockCount > 0) return;
  if (pdpSidebarDesktopLockActive) {
    unlockPdpSidebarDesktopScroll();
    return;
  }
  var scrollY = pdpSidebarSavedScrollY;

  // Disable scroll anchoring for the restore — removing body{position:fixed} below can
  // otherwise trigger a scroll-anchor adjustment on the newly-unlocked document that
  // fights the scrollTo calls that follow.
  document.documentElement.style.setProperty('overflow-anchor', 'none');
  document.body.style.setProperty('overflow-anchor', 'none');

  // scrollTo BEFORE removing position:fixed — removing it snaps scrollY to 0 for one
  // paint frame otherwise (body was pinned at that 0 the whole time the lock was on);
  // setting the real scroll position first means the browser restores it atomically
  // the instant fixed positioning is lifted, same trick as the Kiwi close flow in
  // product-parallax-mobile.js (settleAfterKiwiClose).
  window.scrollTo(0, scrollY);

  document.documentElement.classList.remove('pdp-sidebar-scroll-lock');
  document.body.classList.remove('pdp-sidebar-scroll-lock');
  document.documentElement.style.overflow = '';
  document.body.style.removeProperty('position');
  document.body.style.removeProperty('top');
  document.body.style.removeProperty('left');
  document.body.style.removeProperty('right');
  document.body.style.removeProperty('width');
  document.body.style.removeProperty('overflow');

  // Re-assert synchronously, same tick — the lock removal above just made the document
  // scrollable again at whatever scrollTop it was frozen at (0, the whole time the lock
  // was on). Without this, that 0 position is what paints on the very next frame,
  // before either rAF below ever runs.
  window.scrollTo(0, scrollY);

  requestAnimationFrame(function () {
    window.scrollTo(0, scrollY);
    requestAnimationFrame(function () {
      window.scrollTo(0, scrollY);
      document.documentElement.style.removeProperty('overflow-anchor');
      document.body.style.removeProperty('overflow-anchor');
      // Scroll is genuinely settled now — safe to let the panel reveal trigger
      // recompute its progress against the real position again.
      if (window._parallaxResumePanelReveal) window._parallaxResumePanelReveal();
      // Toolbar may have shown/hidden while scroll was locked (drawer stayed open
      // longer than the Kiwi popup case), leaving the frozen --pdp-vh gallery
      // height stale — same resync product-parallax-mobile.js's settleAfterKiwiClose
      // already does for the direct-Kiwi-popup path. Without it the gallery silently
      // resizes on the next native resize event instead of right here, reading as a
      // jump once the drawer is out of the way.
      if (typeof window._pdpVhSync === 'function') window._pdpVhSync();
    });
  });
}

class PdpSidebarPanel extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    // Move the panel to <body> so it escapes the section's stacking context
    // and sits above the sticky header (z-index: 1001 vs header's sticky context)
    document.body.appendChild(this);

    const sidebarId = this.dataset.sidebarId;
    const overlay = this.querySelector('.pdp-sidebar-overlay');
    const panel = this.querySelector('.pdp-sidebar');
    const body = this.querySelector('.pdp-sidebar__body');
    const closeBtn = this.querySelector('.pdp-sidebar__close');
    // this.desktopScrollbarMediaQuery = window.matchMedia('(min-width: 768px)');

    const lockScroll = () => {
      lockPdpSidebarPageScroll();
    };

    const unlockScroll = () => {
      unlockPdpSidebarPageScroll();
    };

    // .section-header (the Shopify section wrapper, a body grid item) is what carries
    // position:sticky/z-index — pinning IT to position:fixed (as window.pdpPinHeader does
    // for the Kiwi flow) pulls it out of the grid entirely, so its track collapses and
    // #MainContent snaps up by one header-height the instant the panel opens. Instead,
    // lock .section-header's own height (keeps its grid track reserved) and only make
    // the inner <sticky-header> element position:fixed, so it pins to the real viewport
    // without disturbing the outer layout.
    const pinHeaderNoShift = () => {
      const sectionHeader = document.querySelector('.section-header');
      const stickyHeaderEl = document.querySelector('sticky-header');
      if (!sectionHeader || !stickyHeaderEl) return;
      const h = sectionHeader.getBoundingClientRect().height;
      // Header may still sit below the announcement bar (not yet scrolled past
      // it) - pinning to top:0 would yank it out of flow and cover the bar
      // instead of sitting where it visually already was.
      const top = Math.max(0, stickyHeaderEl.getBoundingClientRect().top);
      sectionHeader.style.setProperty('height', h + 'px', 'important');
      sectionHeader.style.setProperty('min-height', h + 'px', 'important');
      stickyHeaderEl.style.setProperty('position', 'fixed', 'important');
      stickyHeaderEl.style.setProperty('top', top + 'px', 'important');
      stickyHeaderEl.style.setProperty('left', '0', 'important');
      stickyHeaderEl.style.setProperty('right', '0', 'important');
      stickyHeaderEl.style.setProperty('z-index', '99999', 'important');
    };

    const unpinHeaderNoShift = () => {
      const sectionHeader = document.querySelector('.section-header');
      const stickyHeaderEl = document.querySelector('sticky-header');
      if (sectionHeader) {
        sectionHeader.style.removeProperty('height');
        sectionHeader.style.removeProperty('min-height');
      }
      if (stickyHeaderEl) {
        stickyHeaderEl.style.removeProperty('position');
        stickyHeaderEl.style.removeProperty('top');
        stickyHeaderEl.style.removeProperty('left');
        stickyHeaderEl.style.removeProperty('right');
        stickyHeaderEl.style.removeProperty('z-index');
      }
    };

    const freezeHeader = () => {
      if (window._parallaxFreezeHeader) {
        window._parallaxFreezeHeader();
        return;
      }
      const stickyHeader = document.querySelector('sticky-header');
      if (!stickyHeader) return;
      stickyHeader.preventHide = true;
      if (stickyHeader.onScrollHandler) {
        window.removeEventListener('scroll', stickyHeader.onScrollHandler);
      }
      if (!stickyHeader.header.classList.contains('shopify-section-header-hidden')) {
        stickyHeader.reveal();
      }
    };

    const unfreezeHeader = () => {
      if (window.__pdpKiwiSettling) return;
      if (window._parallaxThawHeader) {
        window._parallaxThawHeader();
        return;
      }
      const stickyHeader = document.querySelector('sticky-header');
      if (!stickyHeader) return;
      stickyHeader.preventHide = false;
      if (stickyHeader.onScrollHandler) {
        window.removeEventListener('scroll', stickyHeader.onScrollHandler);
        setTimeout(() => {
          if (stickyHeader.onScrollHandler) {
            stickyHeader.currentScrollTop = window.scrollY;
            window.addEventListener('scroll', stickyHeader.onScrollHandler, false);
          }
        }, 100);
      }
    };

    const open = () => {
      panel.classList.remove('is-closing');
      overlay.classList.remove('is-closing');

      // Make the overlay fully opaque INSTANTLY (no fade-in transition) before doing
      // any layout-shifting work below. pinHeaderNoShift()/lockScroll() force the
      // sticky header and sticky media-gallery to recompute their position — if the
      // overlay is still transparent while that happens (previous approach: fade it
      // in via rAF, same tick as the reflow), that recompute flashes the header/
      // gallery visibly for one frame before the overlay dims them out. Snapping it
      // opaque first hides that reflow completely; only the panel needs to actually
      // animate into view.
      overlay.style.setProperty('transition', 'none', 'important');
      overlay.style.display = 'block';
      overlay.style.opacity = '1';

      // Pin BEFORE the scroll lock — reads offsetHeight while body is still in normal flow.
      pinHeaderNoShift();
      lockScroll();
      freezeHeader();

      requestAnimationFrame(() => {
        // Bail if close() already ran mid-flight (e.g. rapid open/close) — it needs
        // the overlay to stay fully opaque until it takes over, per the note in close().
        if (panel.classList.contains('is-closing')) return;
        overlay.style.opacity = '0';
        requestAnimationFrame(() => {
          if (panel.classList.contains('is-closing')) return;
          overlay.style.removeProperty('transition');
          overlay.style.removeProperty('opacity');
          overlay.classList.add('is-open');
          panel.classList.add('is-open');
        });
      });
      closeBtn.focus();
    };

    const close = () => {
      panel.classList.add('is-closing');

      // Guard against open()'s two-frame fade-in being interrupted mid-flight (e.g.
      // closed again immediately after opening, while the overlay is momentarily
      // transparent between its two rAFs): force it fully opaque and flush that as
      // a real committed style *before* adding is-closing below, so the fade-out
      // always animates from opaque and unlockScroll() further down is always
      // hidden behind a solid overlay, regardless of which frame this interrupts.
      overlay.style.setProperty('transition', 'none', 'important');
      overlay.style.opacity = '1';
      overlay.offsetHeight;
      overlay.style.removeProperty('transition');
      overlay.style.removeProperty('opacity');

      overlay.classList.remove('is-open');
      overlay.classList.add('is-closing');
      // Restore scroll immediately, while overlay is still fully opaque —
      // iOS's body position:fixed removal snaps the page instantly, and if
      // that happens after the overlay has started fading (previous approach:
      // unlock on panel transitionend) the background is briefly visible
      // through the semi-transparent overlay = flash. Unlocking now hides
      // the jump behind the still-opaque overlay.
      unpinHeaderNoShift();
      unlockScroll();
      // unfreezeHeader AFTER unlockScroll — releasing preventHide before scroll is
      // restored lets sticky-header's onScroll fire with stale position = header flash.

      const onTransitionEnd = () => {
        panel.classList.remove('is-open', 'is-closing');
        overlay.classList.remove('is-closing');
        overlay.style.display = 'none';
        unfreezeHeader();
        restoreKiwiHome();
        panel.removeEventListener('transitionend', onTransitionEnd);
      };

      panel.addEventListener('transitionend', onTransitionEnd);

      // Fallback in case transitionend doesn't fire
      setTimeout(() => {
        if (panel.classList.contains('is-closing')) {
          panel.classList.remove('is-open', 'is-closing');
          overlay.classList.remove('is-closing');
          overlay.style.display = 'none';
          unfreezeHeader();
          restoreKiwiHome();
        }
      }, 650);
    };

    const isSizeFitTrigger = (btn) => btn.dataset.sizeGuideTrigger === 'true';

    // Kiwi Sizing normally shows its chart in its own centered popup ("vanilla-modal",
    // class names below match this site's existing Kiwi CSS overrides in base.css). For
    // the size-guide trigger we want that same live chart content inside this sidebar
    // instead — so once Kiwi opens its popup we reparent `.kiwi-sizing-modal-inner` into
    // our own panel body and suppress Kiwi's own overlay, rather than showing its popup.
    const KIWI_SEL = '.ks-chart-modal-link, .ks-chart-modal-button, .ks-calculator-modal-link, .ks-calculator-modal-button';
    const CHART_SEL = '#KiwiSizingChart, [data-kiwi-size-chart]';
    // product-swatches.liquid renders a static `.ks-chart-modal-link` placeholder inside
    // the chart container so the link is visible before Kiwi's script runs (data-ks-placeholder
    // marks it). That placeholder matches KIWI_SEL too, so without excluding it here the scan
    // below latches onto the inert placeholder as the "real" trigger, disconnects the observer
    // that would otherwise wait for Kiwi's actual link/button, and firing a click on it does
    // nothing — leaving this sidebar with no chart content to move in (empty panel on open).
    const findKiwiTrigger = (chart) => {
      const match = chart.querySelector(KIWI_SEL + ', a, button');
      return match && !match.hasAttribute('data-ks-placeholder') ? match : null;
    };
    const KIWI_MODAL_SEL = '.kiwi-sizing-modal, .vanilla-modal.kiwi-sizing-modal';
    const KIWI_MODAL_INNER_SEL = '.kiwi-sizing-modal-inner';
    let kiwiTrigger = null;
    let kiwiReady = false;
    let kiwiObserver = null;
    let kiwiObserverTimeout = null;
    let kiwiInnerNode = null;
    let kiwiHomeParent = null;
    let kiwiHomeNextSibling = null;
    let kiwiSlot = null;

    // product-parallax-mobile.js's own Kiwi click listener normally calls
    // e.preventDefault() when the trigger is a bare `#`/hash <a> (its actual purpose is
    // just a JS hook, not real navigation) — but fireKiwiSuppressed below makes that
    // listener skip itself entirely, which also skips that preventDefault call. Without
    // taking it over here, dispatching this synthetic click lets the browser run its
    // native anchor default: jumping the whole page to the top.
    const fireKiwi = (el) => {
      const href = el.getAttribute && el.getAttribute('href');
      const isBareHashAnchor = el.tagName === 'A' && (!href || href === '#' || href.charAt(0) === '#');
      if (isBareHashAnchor) {
        el.addEventListener('click', function preventNav(e) { e.preventDefault(); }, { once: true, capture: true });
      }
      el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    };
    // product-parallax-mobile.js has its own document click listener for these same
    // Kiwi link classes, which locks page scroll expecting Kiwi's own popup to open.
    // Since we're redirecting that popup into this sidebar instead, flag the click so
    // that other listener skips its lock — this sidebar's own open()/close() already
    // handle scroll lock. Flag only needs to live for this synchronous dispatch.
    //
    // That suppressed listener is ALSO what pauses the parallax panel's reveal before
    // Kiwi's own click handling applies its own body{position:fixed} lock (see the
    // "Kiwi sets body position:fixed" comment in product-parallax-mobile.js) — without
    // it, Kiwi's lock zeroes window.scrollY completely unguarded, which the panel's
    // scroll-driven reveal reads as "scrolled to top" and collapses (the whole page
    // visually snaps up to the media gallery). Do the pause ourselves here, first, and
    // stash the still-real scrollY — by the time lockPdpSidebarPageScroll() runs later
    // (from this panel's own open()), Kiwi's lock is already active and window.scrollY
    // would read 0, not the real pre-open position.
    const fireKiwiSuppressed = (el) => {
      if (window._parallaxPausePanelReveal) window._parallaxPausePanelReveal();
      window.__pdpSidebarPreLockScrollY = window.scrollY;
      window.__pdpSidebarClaimsKiwi = true;
      try {
        fireKiwi(el);
      } finally {
        window.__pdpSidebarClaimsKiwi = false;
      }
    };
    const sizeGuideButtons = () => Array.from(document.querySelectorAll(`[data-sidebar-target="${sidebarId}"]`)).filter(isSizeFitTrigger);
    const setSizeGuideVisible = (visible) => sizeGuideButtons().forEach((b) => { b.hidden = !visible; b.style.visibility = visible ? 'visible' : 'hidden'; });

    const ensureKiwiSlot = () => {
      if (kiwiSlot) return kiwiSlot;
      kiwiSlot = document.createElement('div');
      kiwiSlot.className = 'pdp-sidebar__kiwi-slot';
      kiwiSlot.hidden = true;
      body.appendChild(kiwiSlot);
      return kiwiSlot;
    };

    // Grabs Kiwi's live popup content (once Kiwi has opened it) and moves it into
    // this sidebar's body, hiding this panel's own static fallback rows. Returns
    // true once the content has been found and moved.
    const moveKiwiIntoSidebar = () => {
      if (kiwiInnerNode) return true;
      const modalRoot = document.querySelector(KIWI_MODAL_SEL);
      const inner = modalRoot && modalRoot.querySelector(KIWI_MODAL_INNER_SEL);
      if (!inner) return false;
      kiwiInnerNode = inner;
      kiwiHomeParent = inner.parentNode;
      kiwiHomeNextSibling = inner.nextSibling;
      const slot = ensureKiwiSlot();
      slot.appendChild(inner);
      slot.hidden = false;
      Array.from(body.children).forEach((child) => { if (child !== slot) child.hidden = true; });
      modalRoot.classList.remove('kiwi-sizing-modal-visible');
      document.documentElement.classList.remove('kiwi-sizing-modal-visible');
      document.body.classList.remove('kiwi-sizing-modal-visible');
      return true;
    };

    // Puts Kiwi's content back where it lived so Kiwi's own internal state/listeners
    // (tied to that DOM node's original position) stay consistent for next time.
    const restoreKiwiHome = () => {
      if (!kiwiInnerNode) return;
      if (kiwiHomeParent) kiwiHomeParent.insertBefore(kiwiInnerNode, kiwiHomeNextSibling);
      if (kiwiSlot) kiwiSlot.hidden = true;
      Array.from(body.children).forEach((child) => { child.hidden = false; });
      kiwiInnerNode = null;
      kiwiHomeParent = null;
      kiwiHomeNextSibling = null;
    };

    const watchChart = (chart) => {
      kiwiObserver?.disconnect();
      clearTimeout(kiwiObserverTimeout);
      kiwiTrigger = null;
      kiwiReady = false;
      setSizeGuideVisible(true);

      kiwiObserver = new MutationObserver(() => {
        clearTimeout(kiwiObserverTimeout);
        kiwiObserverTimeout = setTimeout(() => {
          kiwiTrigger = findKiwiTrigger(chart);
          if (kiwiTrigger) { kiwiReady = true; kiwiObserver?.disconnect(); }
        }, 100);
      });
      kiwiObserver.observe(chart, { childList: true, subtree: true });
      kiwiObserver.takeRecords(); // flush sync

      // run initial scan
      kiwiTrigger = findKiwiTrigger(chart);
      if (kiwiTrigger) { kiwiReady = true; kiwiObserver.disconnect(); }

      setTimeout(() => { kiwiReady = true; }, 5000);
    };

    const initChart = document.querySelector(CHART_SEL);
    if (!initChart || !sizeGuideButtons().length) {
      kiwiReady = true;
      if (!initChart) setSizeGuideVisible(false);
    } else {
      watchChart(initChart);
    }

    document.addEventListener('kiwi:reloaded', (e) => {
      const c = e.detail?.chart || document.querySelector(CHART_SEL);
      if (c) watchChart(c);
    });

    const handleTriggerClick = (e) => {
      // The inline size-guide link IS kiwiTrigger itself, so fireKiwiSuppressed()'s
      // synthetic dispatch on it re-enters this listener — skip untrusted (synthetic)
      // events so that dispatch falls through to Kiwi's own handling instead of looping.
      if (!e.isTrusted) return;
      const btn = e.target.closest(`[data-sidebar-target="${sidebarId}"]`);
      if (!btn) return;

      if (!isSizeFitTrigger(btn)) { open(); return; }

      e.preventDefault(); e.stopPropagation();
      if (!pdpSidebarPageLoaded) return;

      const moveWhenReady = () => {
        if (moveKiwiIntoSidebar()) return;
        requestAnimationFrame(moveWhenReady);
      };

      // fireKiwiSuppressed MUST run before open()/lockScroll — Kiwi's own click
      // handling applies its own body scroll-lock using whatever window.scrollY reads
      // at that instant. If our lock (body position:fixed) had already landed first,
      // Kiwi would read scrollY as 0 and stamp body.style.top back to 0, snapping the
      // page — and the sticky media gallery near the top — into view for a frame.
      // Firing Kiwi first, then our own open()/lock immediately after in the same
      // synchronous tick, means ours is the one left standing before any paint, and
      // the panel still opens with no visible delay.
      if (kiwiTrigger) {
        fireKiwiSuppressed(kiwiTrigger);
        open();
        moveWhenReady();
        return;
      }

      // kiwiTrigger can still be null here even after Kiwi has actually finished loading —
      // the 5s watchdog above may have already flipped kiwiReady before Kiwi injected its
      // real link/button. Re-scan once, live, before trusting that stale state.
      const chartNow = document.querySelector(CHART_SEL);
      const freshTrigger = chartNow && findKiwiTrigger(chartNow);
      if (freshTrigger) {
        kiwiTrigger = freshTrigger;
        kiwiReady = true;
        fireKiwiSuppressed(kiwiTrigger);
        open();
        moveWhenReady();
        return;
      }
      if (kiwiReady || !chartNow) { open(); return; }

      const start = Date.now();
      const wait = setInterval(() => {
        if (kiwiTrigger) {
          clearInterval(wait);
          fireKiwiSuppressed(kiwiTrigger);
          open();
          moveWhenReady();
        }
        else if (kiwiReady || Date.now() - start > 150) { clearInterval(wait); open(); }
      }, 50);
    };

    // Capture phase: the inline size-guide link is Kiwi's own trigger element, so its
    // click handler runs before a bubble-phase listener here would get a turn.
    document.addEventListener('click', handleTriggerClick, true);
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    });

    // Mobile swipe-to-close: dragging left-to-right anywhere on the panel dismisses
    // it, mirroring the direction it slides out in (translateX(100%) on close).
    // Desktop/tablet (>=1024, same breakpoint the "Shop the Look" trigger below uses)
    // keeps the X-icon-only close — touch-capable laptops/2-in-1s shouldn't have
    // an incidental horizontal drag over the panel close it.
    // Capture phase (not bubble) so this always gets first look at the touch, even
    // when the gesture starts inside the reparented Kiwi size-chart widget — that
    // widget has its own touch handling (e.g. a native horizontal-scroll table), and
    // a bubble-phase listener here would never see the event if Kiwi's own handler
    // consumes it first.
    const SWIPE_CLOSE_THRESHOLD = 70;
    const isMobileViewport = () => window.innerWidth < 1024;
    let swipeStartX = 0;
    let swipeStartY = 0;
    let swipeIsHorizontal = null;
    let swipeTracking = false;
    let swipeArmed = false;

    panel.addEventListener('touchstart', (e) => {
      swipeTracking = false;
      swipeArmed = false;
      if (!isMobileViewport()) return;
      if (!panel.classList.contains('is-open') || panel.classList.contains('is-closing')) return;
      swipeStartX = e.touches[0].clientX;
      swipeStartY = e.touches[0].clientY;
      swipeIsHorizontal = null;
      swipeTracking = true;
    }, { capture: true, passive: true });

    panel.addEventListener('touchmove', (e) => {
      if (!swipeTracking || !panel.classList.contains('is-open')) return;
      const touch = e.touches[0];
      const dx = touch.clientX - swipeStartX;
      const dy = touch.clientY - swipeStartY;

      if (swipeIsHorizontal === null) {
        if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
        // Require a clearly rightward, mostly-horizontal drag so an ordinary vertical
        // scroll (or a diagonal wobble at the start of one) never gets mistaken for it.
        swipeIsHorizontal = dx > 0 && Math.abs(dx) > Math.abs(dy) * 1.5;
      }
      if (!swipeIsHorizontal) return;

      // Claim the gesture (blocks Kiwi's own native horizontal scroll/swiper too,
      // since this capture-phase preventDefault runs before it) but only ARM the
      // close here — actually closing has to wait for touchend/touchcancel below.
      // Running close() mid-gesture, while the finger is still down, tears down the
      // scroll lock (position:fixed removal + a programmatic scrollTo) while iOS's
      // native touch/scroll engine is still live for this same touch, and the two
      // fight — that's what read as the page content visibly jumping on a real
      // device. Waiting for the finger to actually lift avoids that race.
      if (e.cancelable) e.preventDefault();
      if (dx >= SWIPE_CLOSE_THRESHOLD) swipeArmed = true;
    }, { capture: true, passive: false });

    const endSwipe = () => {
      const wasArmed = swipeArmed;
      swipeTracking = false;
      swipeArmed = false;
      if (wasArmed) close();
    };
    panel.addEventListener('touchend', endSwipe, { capture: true, passive: true });
    panel.addEventListener('touchcancel', endSwipe, { capture: true, passive: true });
  }

}

customElements.define('pdp-sidebar-panel', PdpSidebarPanel);

// Shop the Look — smooth scroll on desktop, accordion on mobile
document.querySelectorAll('.pdp-sidebar-trigger--scroll').forEach((btn) => {
  btn.addEventListener('click', () => {
    const targetId = btn.dataset.scrollTo;
    const target = document.getElementById(targetId);
    if (!target) return;

    const isMobile = window.innerWidth < 1024;

    if (isMobile) {
      // Mobile: accordion behavior
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      const plusIcon = btn.querySelector('.pdp-sidebar-trigger__icon--plus');
      const minusIcon = btn.querySelector('.pdp-sidebar-trigger__icon--minus');
      
      if (isExpanded) {
        // Collapse
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('is-open');
        target.classList.add('is-collapsed');
        target.style.maxHeight = '0';
        target.style.opacity = '0';
        
        // Show plus icon, hide minus icon
        if (plusIcon) {
          plusIcon.style.display = '';
          plusIcon.setAttribute('aria-hidden', 'true');
        }
        if (minusIcon) {
          minusIcon.style.display = 'none';
          minusIcon.setAttribute('aria-hidden', 'false');
        }
      } else {
        // Expand
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('is-open');
        target.classList.remove('is-collapsed');
        target.style.maxHeight = target.scrollHeight + 'px';
        target.style.opacity = '1';
        
        // Hide plus icon, show minus icon
        if (plusIcon) {
          plusIcon.style.display = 'none';
          plusIcon.setAttribute('aria-hidden', 'false');
        }
        if (minusIcon) {
          minusIcon.style.display = '';
          minusIcon.setAttribute('aria-hidden', 'true');
        }
        
        // Scroll to the button after expansion
        setTimeout(() => {
          btn.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 300);
      }
    } else {
      // Desktop: smooth scroll behavior
      const start = window.scrollY;
      const end = target.getBoundingClientRect().top + window.scrollY - 0;
      const distance = end - start;
      const duration = 700;
      let startTime = null;

      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);
        window.scrollTo(0, start + distance * easeInOutCubic(progress));
        if (progress < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }
  });
});

// Preserve scroll when Kiwi's own modal locks/unlocks body overflow.
// Guard prevents double-registration when product-card.js also loads on PDP.
(function () {
  if (window._kiwiScrollGuardInit) return;
  window._kiwiScrollGuardInit = true;

  let _kiwiScrollY = null;

  new MutationObserver(() => {
    const kiwiModalVisible =
      document.body.classList.contains('kiwi-sizing-modal-visible') ||
      document.documentElement.classList.contains('kiwi-sizing-modal-visible') ||
      !!document.querySelector('.kiwi-sizing-modal-visible, .vanilla-modal-visible');
    const isSidebarLock = !!document.querySelector('.pdp-sidebar.is-open, .pdp-sidebar.is-closing');

    if (kiwiModalVisible && !isSidebarLock && _kiwiScrollY === null) {
      const guard = window.__pdpKiwiScrollGuardState;
      const bodyTop = parseInt(document.body.style.top || '0', 10);
      if (guard && guard.hasSavedScroll) {
        _kiwiScrollY = guard.scrollY;
      } else if (bodyTop < 0) {
        _kiwiScrollY = -bodyTop;
      } else {
        _kiwiScrollY = window.scrollY || 0;
      }
      if (window.__pdpKiwiSaveScrollPosition) window.__pdpKiwiSaveScrollPosition(_kiwiScrollY);
    } else if (!kiwiModalVisible && _kiwiScrollY !== null) {
      const y = _kiwiScrollY;
      _kiwiScrollY = null;
      if (typeof window.__pdpSettleAfterKiwiClose === 'function') {
        window.__pdpSettleAfterKiwiClose(y, null);
      } else {
        requestAnimationFrame(function () {
          window.scrollTo(0, y);
          requestAnimationFrame(function () {
            if (window._parallaxThawHeader) window._parallaxThawHeader();
          });
        });
      }
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['style'] });
}());
